import { ResponseError } from "@freightsimple/generated-dashboard-openapi-client/runtime";

/** The reason the API gave for refusing, when the body carries one. */
export async function refusalMessage(
  error: ResponseError,
): Promise<string | undefined> {
  try {
    const body: unknown = await error.response.json();
    if (
      body instanceof Object &&
      "error" in body &&
      typeof body.error === "string"
    ) {
      return body.error;
    }
  } catch {
    // A body we can't read tells us nothing — the caller falls back to its own
    // wording.
  }

  return undefined;
}
